 const categories = [
     {
         title: {
             de: "Trensen und Zubehör",
             nl: "Hoofdstellen en toebehoren"
         },
         description: {
             de: `Auf der Suche nach einer neuen Trense oder passendem Zubehör?

Entdecke unsere Auswahl und gib deinem Pferd Komfort, Stil und optimale Leistung. Eine gut sitzende Trense sorgt für klare Kommunikation, mehr Kontrolle und zusätzlichen Komfort. Erhältlich in verschiedenen Größen und Ausführungen, sodass du immer die perfekte Passform findest.

Ergänze deine Ausrüstung mit Hilfszügeln wie Martingalen, Ausbindern und Schlaufzügeln – ideal zur Unterstützung im Training, wenn sie korrekt eingesetzt werden.

Setze auf Qualität, Komfort und eine optimale Zusammenarbeit mit deinem Pferd.`,
             nl: `Op zoek naar een nieuw hoofdstel of toebehoren?

Ontdek onze collectie en geef jouw paard comfort, stijl én optimale prestaties. Een goed passend hoofdstel zorgt voor duidelijke communicatie, meer controle en extra comfort. Verkrijgbaar in diverse maten en uitvoeringen, zodat je altijd de perfecte pasvorm vindt.

Maak je uitrusting compleet met onze hulpteugels, zoals martingalen, bijzetteugels en slofteugels. Ideaal ter ondersteuning van training en rijwerk – mits correct gebruikt.

Kies voor kwaliteit, comfort en een optimale samenwerking met je paard.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_1.webp"
     },
     {
         title: {
             de: "Gebisse",
             nl: "Bitten"
         },
         description: {
             de: `Ein gut passendes Gebiss trägt zu einer klaren Kommunikation zwischen Reiter und Pferd bei und unterstützt Komfort sowie Entspannung beim Reiten.

Gebisse gibt es in vielen Varianten, wie einfach- und doppelt gebrochene Gebisse, Stangengebisse und spezielle Modelle für empfindliche Pferdemäuler. Die Wahl des richtigen Gebisses hängt unter anderem vom Maulbau des Pferdes, dem Ausbildungsstand und dem Reitstil ab.

Auch das Material spielt eine wichtige Rolle, beispielsweise Edelstahl, Kupferlegierungen oder Kunststoff – jedes mit eigenen Eigenschaften und Einfluss auf Speichelbildung und Akzeptanz.

Es ist wichtig, ein Gebiss korrekt anzupassen und regelmäßig auf Abnutzung oder Schäden zu kontrollieren.`,
             nl: `Een goed passend bit draagt bij aan duidelijke communicatie tussen ruiter en paard en ondersteunt comfort en ontspanning tijdens het rijden.

Paardenbitten zijn verkrijgbaar in diverse uitvoeringen, zoals enkel- en dubbelgebroken bitten, stangen en speciale ontwerpen voor gevoelige monden. De keuze van het juiste bit hangt onder andere af van de bouw van de paardenmond, het opleidingsniveau en de rijstijl.

Ook het materiaal speelt een belangrijke rol; denk aan roestvrij staal, koperlegeringen of kunststof.

Het is belangrijk om een bit correct te passen en regelmatig te controleren op slijtage of beschadigingen.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_2.webp"
     },
     {
         title: {
             de: "Beinschutz",
             nl: "Beenbeschermers"
         },
         description: {
             de: `Beinschutz für Pferde schützt die empfindlichen Beine während Training, Transport und Weidegang. Sie helfen, Verletzungen vorzubeugen und bieten zusätzliche Unterstützung.

Es gibt verschiedene Arten, wie Sehnenschoner, Fesselkopfschoner und Bandagen, jeweils mit eigener Funktion. Eine gute Passform und atmungsaktive Materialien sind entscheidend für Komfort und Sicherheit.`,
             nl: `Beenbeschermers voor paarden beschermen de kwetsbare benen tijdens training, transport en weidegang. Ze helpen blessures te voorkomen en bieden extra ondersteuning.

Er zijn verschillende soorten, zoals peesbeschermers, kogelbeschermers en bandages, elk met een eigen functie.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_3.webp"
     },
     {
         title: {
             de: "Pferdedecken",
             nl: "Dekens"
         },
         description: {
             de: `Pferdedecken sind unverzichtbar für Pflege und Schutz deines Pferdes. Sie helfen, dein Pferd bei kaltem oder nassem Wetter warm und trocken zu halten.

Es gibt verschiedene Arten, wie Regendecken, Winterdecken und Fliegendecken, jeweils angepasst an unterschiedliche Bedingungen.

Beim Kauf sollte auf Passform, Material und Füllung geachtet werden, damit dein Pferd sich wohlfühlt und genügend Bewegungsfreiheit hat.`,
             nl: `Paardendekens zijn onmisbaar voor de verzorging en bescherming van je paard. Ze helpen om je paard warm en droog te houden bij koud of nat weer.

Er zijn verschillende soorten dekens, zoals regendekens, winterdekens en vliegendekens.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_4.webp"
     },
     {
         title: {
             de: "Pflege und Putzen",
             nl: "Poetsen en toiletteren"
         },
         description: {
             de: `Auf der Suche nach zuverlässigem Putzzeug für dein Pferd? Eine gute Pflege beginnt mit dem richtigen Equipment.

Mit Bürsten, Hufkratzern und Pflegeprodukten hältst du das Fell deines Pferdes gesund, glänzend und sauber. Ob tägliche Pflege oder Vorbereitung auf ein Turnier – mit den richtigen Tools wird alles einfacher.

Zur Aufbewahrung eignet sich eine Putzkiste oder Putztasche ideal.`,
             nl: `Op zoek naar betrouwbare poetsspullen voor je paard?

Met borstels, hoevenkrabbers en verzorgingsproducten houd je de vacht gezond en schoon.

Een poetskist of poetstas is ideaal om alles netjes te bewaren.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_2.webp"
     },
     {
         title: {
             de: "Ergänzungsfutter",
             nl: "Supplementen"
         },
         description: {
             de: `Ergänzungsfutter für Pferde unterstützt Gesundheit, Leistung und Regeneration.

Es gibt verschiedene Arten, zum Beispiel für Gelenke, Verdauung, Fell und Hufe. Auch für stressanfällige Pferde oder Sportpferde gibt es spezielle Produkte.`,
             nl: `Supplementen voor paarden ondersteunen gezondheid, prestaties en herstel.

Er zijn verschillende soorten, zoals voor gewrichten, spijsvertering, vacht en hoeven.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_3.webp"
     },
     {
         title: {
             de: "Sattelzubehör",
             nl: "Zadeltoebehoren"
         },
         description: {
             de: `Wir bieten eine Auswahl an Sattelgurten und Schabracken für optimale Leistung und Komfort.

Sattelgurte sorgen für gleichmäßige Druckverteilung und reduzieren Scheuern. Sie sind in verschiedenen Materialien erhältlich.

Schabracken unterstützen die Feuchtigkeitsregulierung, schützen den Pferderücken und stabilisieren den Sattel. Zudem sind sie in verschiedenen Designs erhältlich.`,
             nl: `Wij bieden een assortiment singels en zadeldekjes.

Ze zorgen voor comfort, bescherming en stabiliteit tijdens het rijden en zijn verkrijgbaar in verschillende materialen en uitvoeringen.`
         },
         bullets: {
             de: [],
             nl: []
         },
         image: "images_general/horse_eq_4.webp"
     },

     {
         title: {
             de: "Stallzubehör",
             nl: "Stal"
         },
         description: {
             de: `Ein gut eingerichteter Pferdestall bildet die Grundlage für Gesundheit, Wohlbefinden und Leistung Ihres Pferdes. Ob Sie privater Pferdehalter sind, eine Pensionsstall betreiben oder eine professionelle Reitanlage führen – hochwertiges Stallzubehör macht den Unterschied.`,
             nl: `Een goed ingerichte paardenstal vormt de basis voor de gezondheid, het welzijn en de prestaties van uw paard. Of u nu een particuliere paardenhouder bent, een pensionstal runt of een professionele manege beheert, kwalitatieve paardenstal benodigdheden maken het verschil.`
         },
         bullets: {
             de: [
                 "Stallinrichtung: Futter- und Tränkebehälter, Sattel- und Zaumzeughalter, Anbindehaken und Ketten, Heunetze und Slowfeeder",
                 "Stallhygiene: Mistgabeln und Mistschaufeln, Schaufeln und Besen, Stroh, Flachs und Holzspäne, Stallreinigungsmittel"
             ],
             nl: [
                 "Stalinrichting: Voer- en drinkbakken, Zadel- en hoofdstelhouders, Vastzethaken en kettingen, Hooinetten en slowfeeders",
                 "Stalhygiëne: Mestvorken en mestboys, Schoppen en bezems, Stro, vlas en houtvezel, Reinigingsproducten voor stallen"
             ]
         },
         image: "images_general/stal.webp"
     }



 ];

export  default categories;
